/**
 * White Label Branding Configuration
 * 
 * This file centralizes all branding elements to support white labeling.
 * Modify this file to rebrand the application.
 */

const brandingConfig = {
  // Basic Information
  appName: "Taxi Ritter",
  companyName: "Taxi Ritter",
  slogan: "Taxi Ritter fährt für Sie!", // White-Label: Slogan anpassen (erscheint z.B. im Login-Bereich)

  // Contact Information
  email: "info@taxi-ritter-esslingen.de",
  phone: "+49 711 50463753",
  address: "Neckarstraße 86, 73728 Esslingen",
  owner: "Nikolaos Theodoridis", // White-Label: Inhaber/Geschäftsführer anpassen (Pflicht für Impressum gemäß TMG § 5)
  website: "https://www.taxi-ritter-esslingen.de", // White-Label: Website-URL anpassen

  // Supervisory Authority (Aufsichtsbehörde für Personenbeförderung)
  // White-Label: An die örtliche Aufsichtsbehörde des Kunden anpassen!
  supervisoryAuthority: {
    name: "Landratsamt Esslingen",
    department: "Straßenverkehrsamt, Sachgebiet 231 Verkehrswesen – Gelegenheitsverkehr",
    address: "Am Aussichtsturm 7, 73207 Plochingen",
  },

  // Data Protection Authority (Datenschutz-Aufsichtsbehörde)
  // White-Label: An das Bundesland des Kunden anpassen! (siehe BRANDING_VERBESSERUNGEN.md Abschnitt 6.4)
  dataProtectionAuthority: {
    name: "Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg",
    address: "Postfach 10 29 32, 70025 Stuttgart",
    phone: "0711 615541-0",
    website: "https://www.baden-wuerttemberg.datenschutz.de",
  },

  // Legal Information
  copyright: `© ${new Date().getFullYear()} Taxi Ritter`,
  
  // Colors
  colors: {
    primary: "#FDDB17", // Markengelb aus dem Kunden-CI
    secondary: "#212121", // Dark Gray
    accent: "#F9A900", // Zweite Markenfarbe aus dem Kunden-CI
    success: "#4CAF50", // Green
    error: "#F44336", // Red
    warning: "#FF9800", // Orange
    info: "#2196F3", // Blue
    background: "#FFFFFF", // White
    text: {
      primary: "#333333", // Near Black
      secondary: "#757575", // Medium Gray
      light: "#FFFFFF", // White
    }
  },
  
  // Logos and Images
  logos: {
    // White-Label-Anpassung: Dieser Mandant führt nur EIN Logo (Wappen und
    // Schriftzug sind eine zusammenhängende Kombi-Marke). Deshalb zeigen
    // primary, icon und mobileLogo auf dieselbe Datei — und in den Layouts
    // wird kein separates Icon davorgestellt, sonst erschiene das Wappen
    // doppelt. Vorbild: Taxi Pinneberg.
    primary: "/assets/TaxiRitter_Logo.png",
    // Gleiche Marke mit weißer Schrift für dunkle Flächen.
    primaryOnDark: "/assets/TaxiRitter_Logo_weiss.png",
    iconOnDark: "/assets/TaxiRitter_Logo_weiss.png",
    icon: "/assets/TaxiRitter_Logo.png",
    favicon: "/favicon.ico",
    mobileLogo: "/assets/TaxiRitter_Logo.png",
  },
  
  // UI Elements
  ui: {
    borderRadius: "4px",
    // 'rounded', 'square', 'pill' — steuert die Eckenrundung aller Buttons
    // (theme.js). NextCab nutzt "pill"; die Landing Page setzt keine eigenen
    // Radien mehr, damit White-Label-Mandanten hier wirklich durchgreifen.
    buttonStyle: "pill",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  
  // Features Config
  features: {
    enableReports: true,
    enableLiveMap: true,
    enableShiftPlanning: true,
  },
  
  // Social Media
  socialMedia: {
    facebook: "https://facebook.com/nextcab",
    twitter: "https://twitter.com/nextcab",
    instagram: "https://instagram.com/nextcab",
  },
};

export default brandingConfig;